"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
/**
 * Calculates a proficiency score based on
 * the recent answer ratings of a card.
 *
 * @param {array} ratings The ratings of answer attempts on the card.
 * @param {number} attemptsCount The number of most recent attempts to use in the calculation.
 */
function calculateProficiencyScore(ratings, attemptsCount) {
    if (attemptsCount === void 0) { attemptsCount = constants_1.RECENT_ATTEMPTS_COUNT; }
    // Get the most recent past ratings
    var recentPastRatings = ratings.slice(-attemptsCount);
    // Calculate the rating by totaling the
    // rating values of recent ratings
    var score = recentPastRatings.reduce(function (total, recentRating) {
        return total + constants_1.RATING_VALUES[recentRating];
    }, 0);
    return score;
}
exports.default = calculateProficiencyScore;
//# sourceMappingURL=calculateProficiencyScore.js.map